import * as React from 'react';

function InvoiceIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={31.866}
      height={31.889}
      viewBox='0 0 31.866 31.889'
      {...props}
    >
      <g id='invoice' transform='translate(-0.5 -0.476)'>
        <g id='Group_1092' data-name='Group 1092'>
          <path
            id='Path_372'
            data-name='Path 372'
            d='M30.463,12.224H26.254V2.4a1.4,1.4,0,0,0-2.245-1.122L21.1,3.455c-4.377-3.269-3.129-3.269-7.478,0C9.264.186,10.5.186,6.135,3.455L3.245,1.281A1.4,1.4,0,0,0,1,2.4V27.657a4.209,4.209,0,0,0,4.209,4.209H27.657a4.209,4.209,0,0,0,4.209-4.209V13.627A1.4,1.4,0,0,0,30.463,12.224ZM5.209,29.06a1.4,1.4,0,0,1-1.4-1.4V5.209c2.806,2.062,1.978,2.02,6.075-1.052,4.349,3.269,3.115,3.269,7.478,0,4.209,3.143,3.4,3.073,6.089,1.052,0,23.5-.112,22.869.239,23.851Zm23.851-1.4a1.4,1.4,0,0,1-2.806,0V15.03H29.06Z'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={1}
          />
          <path
            id='Path_373'
            data-name='Path 373'
            d='M6.4,10.806h4.209a1.4,1.4,0,0,0,0-2.806H6.4a1.4,1.4,0,0,0,0,2.806Z'
            transform='translate(1.612 2.821)'
            stroke='#fff'
            strokeWidth={1}
          />
          <path
            id='Path_374'
            data-name='Path 374'
            d='M17.627,12H6.4a1.4,1.4,0,0,0,0,2.806H17.627a1.4,1.4,0,0,0,0-2.806Z'
            transform='translate(1.612 4.433)'
            stroke='#fff'
            strokeWidth={1}
          />
          <path
            id='Path_375'
            data-name='Path 375'
            d='M17.627,16H6.4a1.4,1.4,0,0,0,0,2.806H17.627a1.4,1.4,0,0,0,0-2.806Z'
            transform='translate(1.612 6.045)'
            stroke='#fff'
            strokeWidth={1}
          />
        </g>
      </g>
    </svg>
  );
}
export default InvoiceIcon;
